import withDropdownTooltip from '../DropdownTooltip/DropdownTooltip';
import EditImageModal from './EditImageModal';

const EditImageButton = () => ('Update Photo');

export default withDropdownTooltip(
  EditImageButton,
  EditImageModal,
);
